module.exports = __webpack_public_path__ + "static/img/014_TO8_1475_og.3fb0ae2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/014_TO8_1475_og.jpg
// module id = K19k
// module chunks = 0